// frontend/src/components/UI/CommentSection.js

import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import axiosInstance from '../../utils/axiosConfig';

const CommentSection = ({ articleId }) => {
  const { user } = useContext(AuthContext);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [error, setError] = useState('');
  const [loginPrompt, setLoginPrompt] = useState(false);

  const fetchComments = async () => {
    try {
      const res = await axiosInstance.get(`/comments/article/${articleId}`);
      setComments(res.data);
    } catch {
      setError('Fehler: Kommentare konnten nicht geladen werden.');
    }
  };

  useEffect(() => {
    fetchComments();
    // eslint-disable-next-line
  }, [articleId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      setLoginPrompt(true);
      return;
    }
    if (!newComment.trim()) return;
    try {
      const res = await axiosInstance.post('/comments', {
        articleId,
        text: newComment.trim()
      });
      setComments([...comments, res.data]);
      setNewComment('');
    } catch {
      setError('Fehler: Kommentar konnte nicht hinzugefügt werden.');
    }
  };

  return (
    <div className="mt-8">
      <h2 className="text-2xl font-heading text-primary mb-4">Kommentare</h2>
      {error && (
        <div className="bg-red-100 text-red-700 p-2 mb-4">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="mb-4">
        <textarea
          className="w-full p-2 border rounded"
          rows="4"
          placeholder="Einen Kommentar schreiben..."
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
        />
        <button
          type="submit"
          className="bg-primary text-white px-4 py-2 rounded mt-2"
        >
          Absenden
        </button>
      </form>

      {loginPrompt && (
        <div className="bg-yellow-100 text-yellow-700 p-2 mb-4">
          Bitte <strong>melden Sie sich an</strong>, bevor Sie einen Kommentar abgeben.
        </div>
      )}

      {comments.length === 0 ? (
        <p>Keine Kommentare vorhanden.</p>
      ) : (
        <div className="space-y-4">
          {comments.map((c) => (
            <div key={c._id} className="border-b pb-2">
              <p className="font-semibold">{c.username}</p>
              <p>{c.text}</p>
              <span className="text-sm text-gray-400">
                {new Date(c.createdAt).toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommentSection;
